export function formatDate(date) {
    date = new Date(date);
    return date.toDateString().substring(4)+", "+date.toLocaleTimeString();
}